import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {WideContent} from "@pg-design/grid-module";
import {flex, mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../atoms/SeoMainHeadline";

export const InvestmentOfferHeaderContent = () => {
    return (
        <WideContent>
            <div css={investmentOfferHeaderContent}>
                <SeoMainHeadline as="h1" fontFamily="secondary" css={headlineStyle}>
                    Zarabiaj na nieruchomościach!
                </SeoMainHeadline>

                <SubHeadline variant="body_copy_0">
                    Inwestycje gwarantujące zysk są na wyciągnięcie ręki. Poniżej znajdziesz najciekawsze oferty mieszkań na wynajem, apartamentów
                    inwestycyjnych, nieruchomości wakacyjnych oraz lokali użytkowych.
                </SubHeadline>
            </div>
        </WideContent>
    );
};

const investmentOfferHeaderContent = (theme: Theme) => css`
    ${flex()};
    flex-direction: column;
    position: relative;

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 52rem;
    }
`;

const headlineStyle = (theme: Theme) => css`
    font-size: 3.6rem;
    font-weight: 400;
    line-height: 4.32rem;
    z-index: 1;
    ${mb(4)};
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
        font-size: 4.8rem;
        line-height: 5.76rem;
        ${mb(2)}
    }
`;

const SubHeadline = styled(Text)`
    text-align: center;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        text-align: left;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {WideContent} from "@pg-design/grid-module";
import {flex, mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../atoms/SeoMainHeadline";

export const InvestmentOfferHeaderContent = () => {
    return (
        <WideContent>
            <div css={investmentOfferHeaderContent}>
                <SeoMainHeadline as="h1" fontFamily="secondary" css={headlineStyle}>
                    Zarabiaj na nieruchomościach!
                </SeoMainHeadline>

                <SubHeadline variant="body_copy_0">
                    Inwestycje gwarantujące zysk są na wyciągnięcie ręki. Poniżej znajdziesz najciekawsze oferty mieszkań na wynajem, apartamentów
                    inwestycyjnych, nieruchomości wakacyjnych oraz lokali użytkowych.
                </SubHeadline>
            </div>
        </WideContent>
    );
};

const investmentOfferHeaderContent = (theme: Theme) => css`
    ${flex()};
    flex-direction: column;
    position: relative;

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 52rem;
    }
`;

const headlineStyle = (theme: Theme) => css`
    font-size: 3.6rem;
    font-weight: 400;
    line-height: 4.32rem;
    z-index: 1;
    ${mb(4)};
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
        font-size: 4.8rem;
        line-height: 5.76rem;
        ${mb(2)}
    }
`;

const SubHeadline = styled(Text)`
    text-align: center;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        text-align: left;
    }
`;
